import { Dialog } from '@reconciliation/components/dialog.js';
export const openDialog = {
  methods: {
    // 申请退款
    reimburse({ money = '89' }) {
      Dialog({
        title: '申请退款',
        dialogVisible: true,
        warnInfo: `<p>确定退款给客户共<span style="color:#D43634;">${money}</span>元</p>`,
        success: params => {
          console.log('提交上来的数据', params);
        },
      });
    },
    // 修改状态
    updateState(row) {
      console.log(row);
      Dialog({
        title: '修改状态',
        dialogVisible: true,
        warnInfo: `<p>确认修改订单状态<span style="color:#D43634;">待支付-已支付</span>?</p>`,
        success: params => {
          console.log('提交上来的数据', params);
          this.updateFailState(params, row);
        },
      });
    },
  },
};
